import { IonIcon } from "@ionic/react";
import { checkmarkCircle } from "ionicons/icons";

interface DateTabProps {
  /** Day label (e.g., "Di 13 dec") */
  label: string;
  /** Number of shifts/slots available */
  count?: number;
  /** Whether this tab is active */
  isActive: boolean;
  /**
   * Je hebt je op deze dag al aangemeld.
   *
   * De dag blijft dan staan -- er valt niets meer te kiezen, maar wel iets te zien. Het vinkje is
   * het antwoord op de vraag die het scherm hiervoor opriep: "is mijn aanmelding wel aangekomen?"
   * Het aantal diensten laten we weg; dat is een aanbod, en dat is hier voorbij.
   */
  claimed?: boolean;
  /** Callback when tab is clicked */
  onClick: () => void;
}

export function ApplicationSignupDateTab({
  label,
  count,
  isActive,
  claimed = false,
  onClick,
}: DateTabProps) {
  return (
    <button
      type="button"
      className="flex flex-shrink-0 flex-col items-center whitespace-nowrap pb-3 pt-2"
      onClick={onClick}
    >
      <div className="flex items-center gap-1.5 px-0 py-2">
        {claimed && (
          <IonIcon icon={checkmarkCircle} className="size-4 text-success-120" aria-hidden="true" />
        )}

        <span
          className={`text-base capitalize tracking-[0.08px] ${
            isActive ? "font-semibold text-txt-primary" : "font-medium text-txt-secondary"
          }`}
        >
          {label}
          {!claimed && count !== undefined && ` (${count})`}
        </span>
      </div>
      {isActive && <div className="h-1 w-full rounded-full bg-txt-primary" />}
    </button>
  );
}
